import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { uniqueId } from 'lodash';
import Translate from '../common/Translate';
import Select from './Select';
import useValue from '../../services/Form/useValue';

const ConditionalSelect = (props) => {
  const { question, elementIds } = props;
  const { questionId, sectionId, formId } = elementIds;
  const { conditions, type } = question;
  const [condition, setCondition] = useValue(formId, sectionId, questionId, type, 'condition');

  let optionsSelect = false;
  if (
    condition !== undefined &&
    condition !== null &&
    Array.isArray(question[condition]) &&
    question[condition].length > 0
  ) {
    optionsSelect = question[condition];
  }

  const onClick = (option) => {
    setCondition(option);
  };

  return (
    <>
      <Condition conditions={conditions} selected={condition} handleClick={onClick} />
      {optionsSelect && <Select {...props} question={{ options: question[condition] }} />}
    </>
  );
};

export default ConditionalSelect;

ConditionalSelect.propTypes = {
  question: PropTypes.shape().isRequired,
  elementIds: PropTypes.shape().isRequired,
};

const Condition = ({ conditions, selected, handleClick }) => {
  return (
    <Row>
      {conditions.map((condition, index) => (
        <Col xs="6" md="3" lg="2" key={uniqueId(index)} data-cy={index}>
          <button
            type="button"
            className={
              selected && selected === condition
                ? 'btn btn-block btn-value mb-3 mr-3 selected'
                : 'btn btn-block btn-value mb-3 mr-3'
            }
            value={condition}
            onClick={() => {
              handleClick(condition);
            }}
          >
            <Translate code={condition} />
          </button>
        </Col>
      ))}
    </Row>
  );
};

Condition.propTypes = {
  conditions: PropTypes.shape().isRequired,
  selected: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
};
